var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1401_7871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.3484V2.375C0.5 1.33945 1.33945 0.5 2.375 0.5H10.3484C10.8456 0.500003 11.3226 0.697548 11.6742 1.04918L19.9508 9.32582C20.683 10.058 20.683 11.2452 19.9508 11.9775L11.9775 19.9508C11.2452 20.683 10.058 20.683 9.32582 19.9508L1.04918 11.6742C0.697548 11.3226 0.500003 10.8456 0.5 10.3484H0.5ZM4.875 3C3.83945 3 3 3.83945 3 4.875C3 5.91055 3.83945 6.75 4.875 6.75C5.91055 6.75 6.75 5.91055 6.75 4.875C6.75 3.83945 5.91055 3 4.875 3Z",
    fill: "#94AAC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1401_7871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.28190293c818eaa391bb7cdac956e680.svg";
export { ForwardRef as ReactComponent };